@if (apple()) {
  <era-pane>
    <h5 class="card-title small-caps"
        i18n>Device Lock</h5>
    <ml-mdm-command-spinner [commandProgress]="commandProgress$">
      <form [formGroup]="deviceLockForm"
            (ngSubmit)="onSubmit()"
            novalidate>
        @if (apple() | os: { macOS: '>=10.8' }) {
          <div class="mb-3">
            <label class="form-label"
                   for="DeviceLockPin"
                   i18n>Pin:</label>
            <input id="DeviceLockPin"
                   type="text"
                   class="form-control"
                   formControlName="deviceLockPin"
                   [class.is-invalid]="deviceLockPin?.invalid && deviceLockPin?.touched" />
            @if (deviceLockPin?.invalid && deviceLockPin?.touched) {
              <div class="invalid-feedback">
                @if (deviceLockPin?.errors?.required) {
                  <div>A pin is required.</div>
                }
                @if (deviceLockPin?.errors?.minLength) {
                  <div>The pin should be 6 digits long.</div>
                }
              </div>
            }
          </div>
        }
        @if (apple() | os: { iOS: '>7.0', macOS: '>=10.14' }) {
          <div class="mb-3">
            <label class="form-label"
                   for="DeviceLockMessage"
                   i18n>Message:</label>
            <input id="DeviceLockMessage"
                   type="text"
                   class="form-control"
                   formControlName="deviceLockMessage" />
          </div>
        }
        @if (apple() | os: { iOS: '>7.0' }) {
          <div class="mb-3">
            <label class="form-label"
                   for="DeviceLockPhoneNumber"
                   i18n>Phone number:</label>
            <input id="DeviceLockPhoneNumber"
                   type="text"
                   class="form-control"
                   formControlName="deviceLockPhoneNumber" />
          </div>
        }
        <button type="submit"
                class="btn btn-primary">Lock</button>
      </form>
    </ml-mdm-command-spinner>
  </era-pane>
}